export interface IItemNode {
  businesses: {
    // _id business: business name
    [key: string]: String
  }
  nodeType: String
}

export interface ITaskSetting {
  key: string
  business: string
  businessName: string
  task: string
  taskName: string
  responsibleForImplementation: string
  activateVehicleStatus: string,
  timeConditions: { [key: string]: any }[]
}

export interface IWorkflowPosition {
  index: number
  nodeType: string
  nodeTypeName: string
  businesses: { [key: string]: string[] }
  tasks: ITaskSetting[]
}

export interface IAddWorkflow {
  name: string
  requireContainerNumber: boolean,
  transportation: string,
  positionNumber: number | null
  positions: IWorkflowPosition[]
  theSamePositions: [number | null, number | null][] | undefined
}

export interface IWorkflow {
  _id: String
  company: String
  name: String
  code: String
  isCont: Boolean
  items: [IItemNode]
  theSameItem: [[String]]
  createdAt: Date
  updatedAt: Date
}

export const rulesAddWorkflow = {
  name: 'required'
  // transportation: 'required'
}
